var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5738 0.5H16C16 4.65368 19.3436 8.01701 23.4758 8.01701H26.5239V10.983C26.5239 15.1367 29.8689 18.5 34 18.5V1.93396C33.9997 1.55374 33.8494 1.18917 33.582 0.920313C33.3146 0.651456 32.952 0.500286 32.5738 0.5Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.5739 8.50036H8C8 12.6537 11.3439 16.017 15.4745 16.017H18.524V18.983C18.524 23.1367 21.869 26.5 26 26.5V9.93396C25.9994 9.55382 25.849 9.18942 25.5817 8.92063C25.3143 8.65183 24.9519 8.50093 24.5739 8.50036Z",
    fill: "url(#paint0_linear_1_720)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5742 16.5H0C0 20.6551 3.3436 24.017 7.47612 24.017H10.5242V26.9844C10.5242 31.1381 13.8693 34.5 18 34.5V17.9354C17.9996 17.5552 17.8493 17.1906 17.5821 16.9216C17.3148 16.6526 16.9524 16.5008 16.5742 16.5Z",
    fill: "url(#paint1_linear_1_720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_720",
    x1: 25.655,
    y1: 8.51911,
    x2: 18.5638,
    y2: 15.7911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_720",
    x1: 18.1323,
    y1: 16.5642,
    x2: 9.93592,
    y2: 24.4951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJira);
export default __webpack_public_path__ + "static/media/ic_jira.ff56497a09cf34b79601df200fade764.svg";
export { ForwardRef as ReactComponent };